import React from "react";
export var TranslateTags = {
    b: function (chunks) { return React.createElement("strong", { key: chunks }, chunks); },
    i: function (chunks) { return React.createElement("em", { key: chunks }, chunks); },
    u: function (chunks) { return React.createElement("u", { key: chunks }, chunks); },
    s: function (chunks) { return React.createElement("s", { key: chunks }, chunks); },
};
// Should be `as const satisfies RawTranslateParams` but the intl-messageformat types don't handle
// JSX functions (though the underlying JS does)
